import Login from "./Login";
import React from "react";
import Register from "./Register";

import { Route, Switch, useRouteMatch } from "react-router-dom";

export const AuthenticationRouter = () => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.url}/register`}>
        <Register />
      </Route>
      <Route path={`${match.url}/login`}>
        <Login />
      </Route>
      <Route path={`${match.url}`}>
        <Login />
      </Route>
    </Switch>
  );
};
